
import { Grid, Typography, Box, Divider } from "@mui/material";
import { mediosMap, tarjetasMap } from "../../../../helpers/mediosPago";

const capitalize = (str = "") =>
  str
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (c) => c.toUpperCase());

const renderKeyValue = (obj, parent = "") => {
  if (!obj || typeof obj !== "object") return null;

  return Object.entries(obj).flatMap(([key, value]) => {
    const titulo = parent
      ? `${parent} - ${capitalize(key)}`
      : capitalize(key);

    if (value && typeof value === "object" && !Array.isArray(value)) {
      return renderKeyValue(value, titulo);
    }

    let finalValue = value;

    if (key === "medioPago") {
      finalValue = mediosMap[value] ?? value;
    }

    if (key.toLowerCase() === "tarjeta") {
      finalValue = tarjetasMap[value] ?? value;
    }

    if (finalValue === null || finalValue === undefined || finalValue === "") {
      finalValue = "No especificado";
    }

    return (
      <Grid item xs={12} md={6} key={`${titulo}-${key}`}>
        <Typography variant="body2">
          <strong>{titulo}:</strong> {String(finalValue)}
        </Typography>
      </Grid>
    );
  });
};

const DatosPagoCliente = ({ datosCli }) => {
  let datos = {};

  if (!datosCli) {
    return (
      <Box p={2}>
        <Typography>No hay datos para mostrar.</Typography>
      </Box>
    );
  }

  try {
    datos =
      typeof datosCli === "string"
        ? JSON.parse(datosCli)
        : datosCli;
  } catch {
    return (
      <Box p={2}>
        <Typography variant="h6" gutterBottom>
          Observación
        </Typography>

        <Typography sx={{ whiteSpace: "pre-line" }}>
          {datosCli}
        </Typography>
      </Box>
    );
  }

  const {
    observacion = "",
    envio = null,
    pago = null,
    mercadoPago = false,
  } = datos;

  return (
    <Box p={2}>

      {/* OBSERVACIÓN */}

      {observacion && (
        <>
          <Typography variant="h6" gutterBottom>
            Observación del Cliente
          </Typography>

          <Typography sx={{ whiteSpace: "pre-line" }}>
            {observacion}
          </Typography>
        </>
      )}

      {/* ENVÍO */}

      {envio && (
        <>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" gutterBottom>
            Datos de Envío
          </Typography>

          <Grid container spacing={2}>

            {envio.metodo && (
              <Grid item xs={12}>
                <Typography>
                  <strong>Método:</strong> {capitalize(envio.metodo)}
                </Typography>
              </Grid>
            )}

            {envio.descripcion && (
              <Grid item xs={12}>
                <Typography>
                  <strong>Descripción:</strong> {envio.descripcion}
                </Typography>
              </Grid>
            )}

            {envio.datos && renderKeyValue(envio.datos)}

          </Grid>
        </>
      )}

      {/* PAGO */}

      {(pago || mercadoPago !== undefined) && (
        <>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" gutterBottom>
            Datos de Pago
          </Typography>

          <Grid container spacing={2}>

            {pago?.metodo && (
              <Grid item xs={12}>
                <Typography>
                  <strong>Método:</strong> {capitalize(pago.metodo)}
                </Typography>
              </Grid>
            )}

            {pago?.datos && renderKeyValue(pago.datos)}

            <Grid item xs={12}>
              <Typography>
                <strong>Mercado Pago:</strong>{" "}
                {mercadoPago ? "Sí" : "No"}
              </Typography>
            </Grid>

          </Grid>
        </>
      )}

      {!observacion && !envio && !pago && (
        <Typography>No hay datos para mostrar.</Typography>
      )}

    </Box>
  );
};

export default DatosPagoCliente;

